import React, { useState } from "react";
import Style from "./ProductItem.module.css";
import {
  faArrowLeft,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AllDiscountProductApi } from "../../Api/BarestSupplierServices";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import SwitchButton from "../SwitchButton/SwitchButton";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { separate } from "../../Functions/NumberSeprator";
import { deleteProductPostApi } from "../../Api/SupplierServices";

const ProductItem = ({ availables, index = 2, search, getProductDetail }) => {
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [item, setItem] = useState(5);
  //////////////////برداشتن تخفیف
  const deleteCategoryDiscount = (id) => {
    const Delete = {
      id: 0,
      product_id: id,
      const: 0,
      precentage: 0,
    };
    AllDiscountProductApi(Delete, (suc) => {
      if (suc.status === 1) {
        succToast("با موفقیت حذف شد ");
        getProductDetail(2);
      } else {
        errorToast("مشکلی پیش آمده");
      }
    });
  };
  //////////////حذف محصول
  const deletProductHandler = (productId) => {
    let info = {
      id: productId,
    };
    deleteProductPostApi(info, (res) => {
      getProductDetail(2);
    });
  };

  let subset = availables.slice(0, item);

  const loadMore = () => {
    if (item === availables.length || item >= availables.length) {
      setHasMoreItems(false);
    } else {
      setTimeout(() => {
        setItem(item + 5);
      }, 2000);
    }
  };
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  return (
    <section className={Style.items}>
      <InfiniteScroll
        loadMore={loadMore}
        hasMore={hasMoreItems}
        loader={
          <PointSpreadLoading
            style={{ height: "3rem", marginInline: "auto" }}
            color={"#ab0c59"}
          />
        }
      >
        {subset
          .filter((val) => {
            if (index === "1") {
              return val.count !== "0";
            } else if (index === "0") {
              return val.count === "0";
            } else {
              return val;
            }
          })
          .filter((value) => {
            if (value.filter === "") {
              return value;
            } else if (value.name.includes(search)) {
              return value;
            }
            return false;
          })
          .map((item) => {
            return (
              <div key={item.id} className={Style.eachItem}>
                <div className={Style.picPart}>
                  <div className={Style.picHolder}>
                    <img
                      src={`https://cdn.barest.ir/product/m/${item.id}.jpg?${randomNumberInRange(1, 1000000000000)}`}
                      alt=""
                    />
                  </div>
                  <div className={Style.textHolder}>
                    <h3 className={Style.name}>{item.name}</h3>
                    <h3 className={Style.count}>
                      تعداد: <span className={Style.num}>{item.count}</span>
                    </h3>
                    {item.off_price === "0" ? (
                      <div className={Style.priceHolder}>
                        <h3 className={Style.price}>
                          {separate(item.price)}
                          <span className={Style.toman}>تومان</span>
                        </h3>
                      </div>
                    ) : (
                      <div className={Style.priceHolder}>
                        <h3 className={Style.price}>
                          <span className={Style.toman}>
                            {separate(item.off_price)}
                          </span>
                          تومان
                        </h3>
                        <h3 className={Style.offPrice}>
                          {separate(item.price)}
                          <span className={Style.discount}>تومان</span>
                        </h3>
                      </div>
                    )}
                    {item.off_price === "0" ? (
                      <h3 style={{ display: "none",fontSize: ".8rem" }}> </h3>
                    ) : (
                      <h3
                        onClick={() => deleteCategoryDiscount(item.id)}
                        className={Style.delete}
                      >
                        حذف تخفیف
                      </h3>
                    )}
                  </div>
                </div>
                <div className={Style.deleteHolder}>
                  <FontAwesomeIcon
                    onClick={() => deletProductHandler(item.id)}
                    className={Style.trashIcon}
                    icon={faTrashAlt}
                  />
                </div>
                <div className={Style.Condition}>
                  <SwitchButton
                    item={item}
                    updateList={() => getProductDetail(2)}
                  />
                  {localStorage.getItem("type") === "food" ? (
                    <Link
                      to={{
                        pathname: `/editdetailproduct/${item.id}`,
                        state: { pId: item },
                      }}
                    >
                      <h4 className={Style.moreDetail}>
                        <FontAwesomeIcon
                          className={Style.icon}
                          icon={faArrowLeft}
                        />
                        ویرایش محصول
                      </h4>
                    </Link>
                  ) : (
                    <Link
                      to={{
                        pathname: `/editeproductsuppermarket/${item.id}`,
                        state: { data: item },
                      }}
                    >
                      <h4 className={Style.moreDetail}>
                        <FontAwesomeIcon
                          className={Style.icon}
                          icon={faArrowLeft}
                        />
                        ویرایش محصول{" "}
                      </h4>
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
      </InfiniteScroll>
    </section>
  );
};
export default ProductItem;
